/**
 * Lo que pintan las pantallas con pestañas cuando la puerta de acceso no pudo leer `GET /me`
 * (006 · T065; research R-20 y R-24, contracts/staff-ui.md §6 y §8):
 *
 * - `OFFLINE`: `OfflineState` **dentro** de la pantalla, con su barra de pestañas.
 * - `ERROR`: `GenericErrorScreen` con la barra de pestañas; nunca el código ni el `request_id`.
 */
import { GenericErrorScreen } from '../../components/ui/generic-error';
import { OfflineState } from '../../components/ui/offline-state';
import { Screen } from '../../components/ui/screen';
import { TabBar, type TabId } from '../../components/ui/tab-bar';

export interface GateFallbackProps {
  status: 'OFFLINE' | 'ERROR';
  retry: () => void;
  /** Pestaña activa de la pantalla que se estaba abriendo. */
  active: TabId;
  /** Título y subtítulo de la pantalla, como en su propio estado sin conexión. */
  title?: string;
  lead?: string;
  /** Solo Inicio: `home-placeholder` es la raíz de la home también sin conexión (wiring §0.8). */
  testId?: string;
}

export function GateFallback({ status, retry, active, title, lead, testId }: GateFallbackProps) {
  const nav = <TabBar active={active} />;
  if (status === 'ERROR') {
    return <GenericErrorScreen nav={nav} onRetry={retry} />;
  }
  return (
    <Screen data-testid={testId} title={title} lead={lead} nav={nav}>
      <OfflineState onRetry={retry} />
    </Screen>
  );
}
